import './main.css';
import './lib/theme.ts';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp } from 'vue';
import App from './App.vue';
import { i18n } from './i18n.ts';
import { queryClient } from './lib/query.ts';
import { router } from './router.ts';

createApp(App).use(i18n).use(router).use(VueQueryPlugin, { queryClient }).mount('#app');
